/**
 * @group Contact
 * @summary Contact methods
 * 
 * @remarks
 * This constant contains the primary contact methods for the company,
 * including email and phone links for direct communication.
 * 
 * @example
 * ```typescript
 * import { CONTACT_METHODS } from '@shared/constants';
 * 
 * CONTACT_METHODS.forEach(method => {
 *   const contactLink = document.createElement('a');
 *   contactLink.href = method.href;
 *   contactLink.textContent = method.label;
 *   contactSection.appendChild(contactLink);
 * });
 * ```
 */
export const CONTACT_METHODS = [
  {
    href: `mailto:help@domain.co.za`,
    label: "help@domain.co.za"
  },
  {
    href: `tel:0000000000`,
    label: "000 000 0000"
  }
] as const; 